// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.versionChannel[data-v-e9fda8ec] {\n  border: 1px solid #0ca040;\n  padding: 5px 15px;\n  border-radius: 20px;\n  color: #0ca040;\n  margin-left: 20px;\n  font-weight: normal;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
